/** Max character level (inclusive). */
export const PROGRESSION_MAX_LEVEL = 100;

/** Cumulative totalExp required to reach this level (Lv1 = 0). */
export const TOTAL_EXP_AT_MAX_LEVEL = 200_000_000;

const THRESHOLDS: number[] = buildCumulativeThresholds();

function buildCumulativeThresholds(): number[] {
  const max = PROGRESSION_MAX_LEVEL;
  const thresholds = new Array<number>(max + 1).fill(0);
  thresholds[1] = 0;

  const rawSteps: number[] = [];
  for (let level = 1; level < max; level++) {
    rawSteps.push(40 + 18 * level + 6 * level ** 1.55);
  }
  const rawSum = rawSteps.reduce((sum, n) => sum + n, 0);
  const scale = TOTAL_EXP_AT_MAX_LEVEL / rawSum;

  let cumulative = 0;
  for (let level = 1; level < max; level++) {
    cumulative += Math.floor(rawSteps[level - 1] * scale);
    thresholds[level + 1] = cumulative;
  }
  thresholds[max] = TOTAL_EXP_AT_MAX_LEVEL;
  return thresholds;
}

export function cumulativeExpForLevel(level: number): number {
  const clamped = Math.min(PROGRESSION_MAX_LEVEL, Math.max(1, Math.floor(level)));
  return THRESHOLDS[clamped] ?? 0;
}

export function xpToNextLevel(level: number): number {
  if (level >= PROGRESSION_MAX_LEVEL) return 0;
  const next = cumulativeExpForLevel(level + 1);
  const cur = cumulativeExpForLevel(level);
  return Math.max(0, next - cur);
}

export function levelFromTotalExp(totalExp: number): number {
  const exp = Math.max(0, Math.floor(totalExp));
  if (exp >= TOTAL_EXP_AT_MAX_LEVEL) return PROGRESSION_MAX_LEVEL;
  for (let level = PROGRESSION_MAX_LEVEL; level >= 1; level--) {
    if (exp >= cumulativeExpForLevel(level)) return level;
  }
  return 1;
}

/** AP granted when crossing into `newLevel` (not on Lv1 creation). */
export function statPointsForLevelUp(newLevel: number): number {
  if (newLevel <= 1 || newLevel > PROGRESSION_MAX_LEVEL) return 0;
  return 2;
}
